import { useState } from 'react';
import { DownloadButton } from './ViewLoadInspectionPhotogridStyledComponents';
import { GetApp } from '@material-ui/icons';
import { downloadMediaAsZip } from 'shared/utils/MediaUtils';
import { useSnackbarStack } from '@superdispatch/ui';

export function ViewLoadInspectionDownloadButton({
  fileUrls,
  fileName,
  type,
}: {
  fileUrls: string[];
  fileName: string;
  type: 'pickup' | 'delivery';
}) {
  const [isDownloading, setIsDownloading] = useState<boolean>();
  const { addSnackbar } = useSnackbarStack();

  const handleDownloadPhotos = () => {
    setIsDownloading(true);

    void downloadMediaAsZip(fileUrls, type, `${fileName}.zip`)
      .catch(() =>
        addSnackbar('An error occurred while downloading the media', {
          variant: 'error',
        }),
      )
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <DownloadButton
      pending={isDownloading}
      variant="neutral"
      onClick={handleDownloadPhotos}
      startIcon={<GetApp color="action" />}
    >
      Download All Photos
    </DownloadButton>
  );
}
